'use client';

import { Sidebar } from '..';
import { usePackStorage } from './usePackStorage';

export function AppLayout({ children }) {
  const { purchasedFreePacksCollective, selectedPack, handlePackChange } = usePackStorage();

  return (
    <div className="flex relative bg-[var(--q3-surface-default)] min-h-screen w-full z-50">
      <div className="flex-shrink-0 sm:w-0 lg:w-[100px]">
        <Sidebar
          purchasedPacks={purchasedFreePacksCollective}
          selectedPack={selectedPack}
          onPackChange={handlePackChange}
        />
      </div>
      <div className="flex-1 min-w-0 overflow-hidden flex justify-center">{children}</div>
    </div>
  );
}
